import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import mobileMockup from "../../Assets/Images/mobileMockup.png";
import googlePlay from "../../Assets/Images/googlePlay.svg";
import appleStore from "../../Assets/Images/appleStore.svg";
import QRg from "../../Assets/Images/Android.png";
import QRa from "../../Assets/Images/iOS.png";
import scroller from "../../Assets/Animations/scroller.json";
import rotar from "../../Assets/Animations/rotar.json";
import rubix from "../../Assets/Animations/rubix.json";
import { useTranslation } from "react-i18next";
import LottiePlayer from "../LottiePlayer/lottiePlayer";
import LazyLoad from "react-lazyload";
const MobileIntro = ({ loaded }) => {
  const { t } = useTranslation();

  return (
    <div className="w-100 my-4 pb-4  m-0 landingDiv d-flex flex-column align-items-center justify-content-center">
      <div className="d-flex w-100 justify-content-center">
        <div className="productSans w-xs-75 text_40 text-center pt-2 mb-3 px-0 ms-lg-5 mt-4 text-black">
          {t("LandingDivText1")}
          <span className="landing_banner_Heading productSansBold">
            {t("LandingDivText2")}
          </span>
        </div>
      </div>
      <div className="w_60 w-xs-90">
        <p className="justify-content-center px-xxl-5 m-0 text-center d-flex align-items-center text_18 text-black productSansLight ">
          {t("LandingDivSubText")}
        </p>
      </div>
      <div className="d-flex w-100 px-4 px-lg-0 justify-content-between">
        <div className="d-flex mt-5 justify-content-end w-25">
          <div className="w-25 w-xs-75 mt-lg-5 m-0 p-0">
            <LottiePlayer src={scroller} />
          </div>
        </div>
        <div className="d-flex justify-content-center w_40 w-xs-100">
          <div className="p-0 mt-4 mt-lg-0">
            <div className="d-flex flex-column justify-content-center">
              {loaded.length >= 1 && (
                <LazyLoad className="d-flex my-2 justify-content-center" once>
                  <img
                    alt="mobile mockup"
                    className="w-75 w-xs-100 p-lg-3 p-0"
                    src={mobileMockup}
                  />
                </LazyLoad>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-start w-25 me-lg-5">
          <div className="marginsAnimations w-100 d-flex flex-column justify-content-between justify-content-lg-center ">
            <div className="d-flex justify-content-center">
              <div className="w-25 w-xs-100 mt-lg-5 m-0">
                <LottiePlayer src={rotar} />
              </div>
            </div>
            <div className="d-flex justify-content-start marginsAnimationsInner">
              <div className="w-25 w-xs-100 mt-5">
                <LottiePlayer src={rubix} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="m-2 d-flex w-100  justify-content-center  flex-column flex-lg-row align-items-center">
        <div className="d-flex  w-xs-50 justify-content-center justify-content-lg-end m-3 m-lg-0 px-lg-2 p-0">
          <LazyLoad
            height={400}
            className="d-flex w-xs-50 justify-content-around"
            once
          >
            <a
              className="d-flex align-items-center"
              href="https://play.google.com/store/apps/details?id=com.whizpool.ezywatermarklite"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="playstore"
                className="mx-lg-1 m-0 size_112"
                src={googlePlay}
              />
            </a>
            <img alt="QR Code" className="mx-lg-2 m-0 size_56x56" src={QRg} />
          </LazyLoad>
        </div>
        <div className="m-1 p-0 d-none d-lg-flex flex-column justify-content-center boder_little"></div>
        <div className="d-flex  w-xs-50 justify-content-center justify-content-lg-start  mx-3 m-lg-0 px-lg-2 p-0">
          <LazyLoad
            height={400}
            className="d-flex w-xs-50 justify-content-around"
            once
          >
            <a
              className="d-flex align-items-center"
              href="https://apps.apple.com/us/app/ezy-watermark-photos-lite/id494473910"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="appstore"
                className="mx-lg-1 m-0 size_112"
                src={appleStore}
              />
            </a>
            <img alt="qra" className="mx-lg-2 m-0 size_56x56" src={QRa} />
          </LazyLoad>
        </div>
      </div>
    </div>
  );
};

export default MobileIntro;
